export class FarmRepository {

  constructor(api) {
    this.api = api
  }
  async create(farm) {
    const {NAME,LAMINA,NOTE,FK_EDITOR}=farm
    const raw = `
      INSERT INTO CROP.FARM (
        NAME,
        LAMINA,
        NOTE,
        FK_EDITOR
      )VALUES(
        "${NAME}",
        "${LAMINA}",
        "${NOTE ||''}",
        ${FK_EDITOR}
      );
    `
    const resp= await this.api.sql({
      data:{
        sql:raw
      }
    })

    return resp
  }

  async delete(id) {
    const raw = `
      DELETE FROM CROP.FARM
      WHERE ID=${id};
    `
    const resp= await this.api.sql({
      data:{
        sql:raw
      }
    })

    return resp
  }
  async updateTime(ID_FARM,TIME){
    const raw = `
      UPDATE CROP.FARM
      SET CROP.FARM.UPDATE = "${TIME}"
      WHERE ID = ${ID_FARM};
    `
    const resp = await this.api.sql({
      data:{
        sql: raw
      }
    })

    return resp
  }

  async updateFkEditor(ID_FARM,FK_EDITOR){
    const raw = `
      UPDATE CROP.FARM
      SET FK_EDITOR = ${FK_EDITOR}
      WHERE ID = ${ID_FARM};
    `
    const resp = await this.api.sql({
      data:{
        sql: raw
      }
    })

    return resp
  }


  async show(){
    const raw = `
    SELECT
      CROP.FARM.*,
      C_USER.NAME AS EDITOR_NAME
    FROM
      CROP.FARM
    LEFT JOIN NEWSIR.CAD_USER AS C_USER
    ON C_USER.ID = FK_EDITOR
    WHERE CROP.FARM.IS_ACTIVE = 1;
    `
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    })

    return resp
  }

  async update(farm) {
    const {ID,NAME,LAMINA,NOTE,FK_EDITOR}=farm
    const raw = `
      UPDATE CROP.FARM
      SET NAME="${NAME}",LAMINA=${LAMINA}, NOTE="${NOTE ||''}", FK_EDITOR=${FK_EDITOR}
      WHERE ID=${ID};
    `
    const resp= await this.api.sql({
      data:{
        sql:raw
      }
    })

    return resp
  }

  async getFarmIdByName(NAME) {
    const raw = `
      SELECT ID FROM CROP.FARM WHERE NAME = '${NAME}';
    `
    // console.log('pegando farm pelo nome', raw)
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    })

    if (!resp[0].length) {
      console.log('[getFarmIdByName] Não há registros de cultivar')
      return null
    }

    return resp[0][0].ID
  }

  async showFarmById(ID) {
    const raw = `SELECT * FROM CROP.FARM WHERE ID = ${ID};`
    return  await this.api.sql({
      data: {
        sql: raw
      }
    })


  }

}
